export default __webpack_public_path__ + "static/mean-dsn-days-small-mobile-8c64792ffad699e29f3ade48a4e59eef.svg";